import errorPageBg from 'assets/images/backgrounds/error-page-bg.jpg';
import { Button } from 'components/buttons';
import { ImageComponent } from 'components/Image';
import { useTheme } from 'hooks/theme';
import type React from 'react';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { ScErrorBlockProps } from './styled';
import { ScErrorBlock } from './styled';

interface ErrorBlockProps extends ScErrorBlockProps {
  withLogo?: boolean;
  text?: string;
  subText?: string | React.ReactNode;
  richText?: React.ReactNode;
  buttonText?: string;
  contactUsTexts?: string;
  handleOpenSupport?: () => void;
}

export const ErrorBlock: FC<ErrorBlockProps> = ({
  text,
  subText,
  richText,
  buttonText,
  withBg,
  withLogo,
  contactUsTexts,
  handleOpenSupport,
}) => {
  const { t } = useTranslation('common');
  const { menu } = useTheme();

  return (
    <ScErrorBlock withBg={withBg}>
      {withBg && (
        <ImageComponent alt="#" className="page-bg" fill src={errorPageBg} />
      )}
      {text && <p className="title">{text}</p>}
      {subText &&
        (typeof subText === 'string' ? (
          <p className="subtitle">{subText}</p>
        ) : (
          subText
        ))}

      {richText && (
        <div className="rich-text">
          {withLogo && <menu.logo.component />}
          {richText}
        </div>
      )}

      {(handleOpenSupport || buttonText) && (
        <div className="buttonWrap">
          {handleOpenSupport && (
            <Button onClick={handleOpenSupport} whiteTransparent xLarge>
              {t('glossary:contactUs')}
            </Button>
          )}
          {contactUsTexts && (
            <Button
              href="mailto:support@luckyelfcasino.com"
              whiteTransparent
              xLarge
            >
              {contactUsTexts}
            </Button>
          )}
          {buttonText && (
            <Button blue to="/" xLarge>
              {buttonText}
            </Button>
          )}
        </div>
      )}
    </ScErrorBlock>
  );
};
